module.exports = __webpack_public_path__ + "img/sealawcove_sample.f2aa59c2.png";